import { ServerCandlesPrice } from "services/types";
import { candleBucket } from "./candleBucket";
import { createLiveCandle } from "./createLiveCandle";

export function applyTick(
  candles: ServerCandlesPrice[],
  price: number,
  timestamp: number,
  timeframeMs: number,
): boolean {
  if (!candles.length) return false;

  const bucket = candleBucket(timestamp, timeframeMs);
  const last = candles[candles.length - 1];
  const lastBucket = candleBucket(Date.parse(last.timestamp), timeframeMs);

  if (bucket === lastBucket) {
    last.high = Math.max(last.high, price);
    last.low = Math.min(last.low, price);
    last.close = price;
    return true;
  }

  if (bucket > lastBucket) {
    const prevClose = last.close;

    candles.push(
      createLiveCandle(
        bucket,
        prevClose,
        Math.max(prevClose, price),
        Math.min(prevClose, price),
        price,
      ),
    );
    return true;
  }

  // bucket < lastBucket: late tick after a newer candle opened — no-op
  return false;
}
